import {createSelector} from 'reselect';

import {ApplicationStoreType} from 'reducers';
import {
    LocationDefaultStateType,
    CountryType,
    CountriesRegionsType,
    RegionsItemType,
} from 'reducers/location/locationType';
import {COUNTRIES} from 'constants/location';

/**
 * Returns locations reducer state
 *
 * @param  {ApplicationStoreType} store - root store
 * @returns {LocationDefaultStateType} - locations reducer
 */
export const getLocationReducer = (store: ApplicationStoreType): LocationDefaultStateType =>
    store.location;

/**
 * Returns list with a countries description
 *
 * @param  {ApplicationStoreType} store - root store
 * @returns {CountryType} - countries description
 */
export const getCountries = (store: ApplicationStoreType): CountryType[] =>
    getLocationReducer(store).countries;

/**
 * Returns list with counties states
 *
 * @param  {ApplicationStoreType} store - root store
 * @returns {CountriesRegionsType} - states of all countries
 */
export const getRegions = (store: ApplicationStoreType): CountriesRegionsType =>
    getLocationReducer(store).regions;

/**
 * Returns states of a country single
 *
 * @param  {ApplicationStoreType} store - root store
 * @param {string} countyCode - code of a country which states are requested
 * @returns {RegionsItemType[] | undefined} - list of states
 */
export const getRegionsByCountry = createSelector(
    [getRegions, (store, countyCode) => countyCode],
    (regions, countyCode): RegionsItemType[] | undefined => regions[countyCode],
);

/**
 * Returns states of the United States
 *
 * @param  {ApplicationStoreType} store - root store
 * @returns {RegionsItemType | undefined} - list of a states of the USA
 */
export const getUSRegions = (store: ApplicationStoreType): RegionsItemType[] | undefined =>
    getRegionsByCountry(store, COUNTRIES.UNITED_STATES);
